import { render, staticRenderFns } from "./PrivacyPolicyToast.vue?vue&type=template&id=902fd072&scoped=true&"
import script from "./PrivacyPolicyToast.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyToast.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPolicyToast.vue?vue&type=style&index=0&id=902fd072&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "902fd072",
  null
  
)

export default component.exports